import { render, staticRenderFns } from "./ModalProjectActivate.vue?vue&type=template&id=522edd43&scoped=true"
import script from "./ModalProjectActivate.vue?vue&type=script&lang=js"
export * from "./ModalProjectActivate.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectActivate.vue?vue&type=style&index=0&id=522edd43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522edd43",
  null
  
)

export default component.exports